/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { IonContent, IonText, IonGrid, IonRow, IonItem, IonCol, IonInput, IonModal, IonButton, IonIcon, IonAlert, IonSelectOption } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { close, addCircle } from 'ionicons/icons'
import SelectNoCache from './SelectNoCache'
import weekdays from '../data/weekdays.json';
import './AlarmModal.css';
import { Units } from '../utils/BMIUtils';

interface AlarmModalProps {
  show: boolean;
  onClose: () => void
  addAlarm: (alarm: any) => void
};

const AlarmModal: React.FC<AlarmModalProps> = ({ show, onClose, addAlarm }) => {

  const [t] = useTranslation();
  const [name, setName] = useState('');
  const [doseAmount, setDoseAmount] = useState(200);
  const [doseUnit, setDoseUnit] = useState('miligrams');
  const [dates, setDates] = useState<string[]>([]);
  const [times, setTimes] = useState(["00:00"]);


  const [showAlert1, setShowAlert1] = useState(false);
  function changeTime(time: string, index: number) {
    times[index] = time;
    setTimes(times);
  }

  function addTime() {
    setTimes(times => [...times, "00:00"]);
  }

  function updateDate(day: string) {
    if (dates.indexOf(day) > -1) {
      setDates(dates.filter(date => date !== day));
    } else {
      setDates(dates => [...dates, day]);
    }
  }

  function addNewAlert() {
    if (!name || !dates.length || !times.length) {
      setShowAlert1(true);
      return;
    } else {
      setName("");
      setDoseAmount(200);
      setDoseUnit("miligrams");
      setDates([]);
      setTimes(["00:00"]);
      addAlarm({
        "name": name,
        "doseAmount": doseAmount,
        "doseUnit": doseUnit,
        "date": dates,
        "time": times
      });
      onClose();
    }
  }

  return (

    <IonModal isOpen={show}>
      <IonContent>
        <div className="modal-content">
          <IonItem lines='none'>
            <IonText color='primary'><b>{t('New')} {t('Alarm')}</b></IonText>
            <IonButton slot="end" fill='clear' onClick={() => onClose()} color='primary'>
              <IonIcon slot='icon-only' icon={close}></IonIcon>
            </IonButton>
          </IonItem>
          <hr />
          <IonGrid>
            <IonRow>
              <IonCol size="12">
                <IonText><b>{t('Name')}</b></IonText>
              </IonCol>
              <IonCol>
                <IonInput className="alarmName" value={name} onIonChange={e => setName(e.detail.value!)}></IonInput>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <IonText><b>{t('Dosage')}</b></IonText>
              </IonCol>
              <IonCol size="6" size-md="4" >
                <IonInput type="number" value={doseAmount} onIonChange={e => setDoseAmount(Number(e.detail.value))}></IonInput>
              </IonCol>
              <IonCol size="6" size-md="4" >
                <SelectNoCache className="formSelect" interface="alert" value={doseUnit} onIonChange={e => setDoseUnit(e.detail.value)}>
                  <IonSelectOption  key={Units.Nanograms} value={Units.Nanograms}>{Units.Nanograms}</IonSelectOption>
                  <IonSelectOption  key={Units.Miligrams} value={Units.Miligrams}>{Units.Miligrams}</IonSelectOption>
                  <IonSelectOption  key={Units.Grams} value={Units.Grams}>{Units.Grams}</IonSelectOption>
                </SelectNoCache>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <IonText><b>{t('What Days')}</b></IonText>
              </IonCol>
              {
                weekdays.map((day: string, index: number) => {

                  return dates.indexOf(day) > -1 ?
                    <IonCol key={day + index} size="auto">
                      <IonButton fill="solid" onClick={() => updateDate(day)}>{t(day)}</IonButton>
                    </IonCol> :
                    <IonCol key={day + index} size="auto">
                      <IonButton fill="outline" onClick={() => updateDate(day)}>{t(day)}</IonButton>
                    </IonCol>
                })
              }
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <IonText><b>{t('What Times')}</b></IonText>
              </IonCol>
              {
                times.map((time: string, index) => {
                  return <IonCol size="6" size-md="4" key={time + index}>
                    <IonInput className="alarmDate" type="time" value={time} onIonChange={e => changeTime(e.detail.value!, index)}></IonInput>
                  </IonCol>
                })
              }
              <IonCol size="6" size-md="4">
                <IonButton fill='clear' onClick={() => addTime()} color='primary'>
                  <IonIcon slot='icon-only' icon={addCircle}></IonIcon>
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
          <hr />
          <IonButton color='primary' onClick={() => addNewAlert()}>{t('Add Reminder')}</IonButton>
          <IonAlert
            isOpen={showAlert1}
            onDidDismiss={() => setShowAlert1(false)}
            header={'Alert'}
            message={'Please put the valid input'}
            buttons={['OK']} />
        </div>
      </IonContent>
    </IonModal>
  );
};

export default AlarmModal;
